<template>
  <div class="addCartSuccess">
    <div class="cart-content-box" v-if="showContent">
      <!-- 提示 -->
      <div class="tip-box">
        <span class="icon-ok"><img src="../assets/img/icon_ok.png"/></span>
        <span>加入购物车成功！</span>
      </div>
      <!-- 书or章节信息 -->
      <div class="cont-box" v-show="showBook">
        <div class="img-box">
          <img :src="bookImgUrl" :onerror="defaultImg" />
        </div>
        <div class="goods-info">
          <h3>{{ bookTitle }}</h3>
          <p>{{ chapterTitle }}</p>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btn-box">
        <div class="look-again-btn" @click="closeTipFn">再逛逛</div>
        <router-link to="/myCart" :target="isPc ? '_blank' : '_self'"
          ><span>去购物车结算</span><i class="el-icon-arrow-right"></i
        ></router-link>
      </div>
      <!-- 倒计时提示 -->
      <div class="countdown-tip">
        <span>{{ num }}</span
        >秒后自动关闭弹窗
      </div>
      <!-- 关闭按钮 -->
      <div class="close-icon" @click="closeTipFn">
        <img src="../assets/img/icon_close_cart.png" />
      </div>
    </div>
    <div class="cart-content-box" v-else>
      <!-- 提示 -->
      <div class="tip-box">
        <span class="icon-ok"><img src="../assets/img/icon_ok.png"/></span>
        <span>该合集内部分图书已购买或已经在您的购物车内了</span>
      </div>
      <!-- 倒计时提示 -->
      <div class="countdown-tip">
        <span>{{ num }}</span
        >秒后自动关闭弹窗
      </div>
      <!-- 关闭按钮 -->
      <div class="close-icon" @click="closeTipFn">
        <img src="../assets/img/icon_close_cart.png" />
      </div>
    </div>
  </div>
</template>

<script>
import common from "../assets/js/common.js";
export default {
  props: {
    showContent: {
      type: Boolean,
      default: true
    },
    showBook: {
      type: Boolean,
      default: true
    },
    bookImgUrl: {
      type: String,
      default: ""
    },
    bookTitle: {
      type: String,
      default: ""
    },
    chapterTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      defaultImg: 'this.src="' + require("../assets/img/default_pic.png") + '"',
      isPc: true,
      num: 8,
      timer: null
    };
  },
  mounted() {
    // 判断是否为pc端
    let wid = window.innerWidth;
    if (wid >= 320 && wid <= 1024) {
      this.isPc = false;
    }

    // 倒计时
    this.timer = setInterval(() => {
      this.num--;
      if (this.num === 0) {
        clearInterval(this.timer);
        this.closeTipFn();
      }
    }, 1000);
  },
  methods: {
    closeTipFn() {
      clearInterval(this.timer);
      common.$emit("closeTip");
    }
  }
};
</script>

<style scoped>
.addCartSuccess {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.cart-content-box {
  position: relative;
}
.cart-content-box .content {
  margin-top: 30px;
  text-align: center;
}
.close-icon {
  position: absolute;
}

/* 倒计时 */
.countdown-tip {
  text-align: center;
  margin-top: 12px;
  font-size: 13px;
  color: #929292;
}

.countdown-tip span {
  color: #ef8264;
}

@media screen and (min-width: 320px) and (max-width: 1024px) {
  /* 内容box */
  .cart-content-box {
    width: 90%;
    min-height: 1.69rem;
    background: #f0f9eb;
    border-radius: 0.1rem;
    padding: 0.22rem;
  }

  /* 提示 */
  .tip-box {
    font-size: 14px;
    font-weight: 500;
    color: #67c23a;
    margin-bottom: 0.18rem;
    display: flex;
    align-items: center;
  }

  .tip-box .icon-ok {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 0.08rem;
  }

  .tip-box .icon-ok img {
    width: 100%;
    height: 100%;
  }

  /* 书or章节信息 */
  .cart-content-box .cont-box {
    display: flex;
  }

  /* 书的封面 */
  .cart-content-box .img-box {
    width: 64px;
    height: 88px;
  }

  .cart-content-box .img-box img {
    width: 100%;
    height: 100%;
  }

  /* title */
  .cart-content-box .goods-info {
    flex: 1;
    margin-left: 0.1rem;
  }

  .cart-content-box .goods-info h3 {
    font-size: 16px;
    font-weight: 500;
    color: #3a3a3a;
    margin: 0 0 0.08rem;
  }

  .cart-content-box .goods-info p {
    font-size: 14px;
    font-weight: 400;
    color: #929292;
    margin: 0;
  }

  /* 按钮 */
  .btn-box {
    display: flex;
    justify-content: center;
    margin-top: 0.1rem;
    font-size: 12px;
  }

  .btn-box .look-again-btn {
    padding: 0 28px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    background: #ffeee9;
    border-radius: 4px;
    border: 1px solid #ef8264;
    color: #ef8264;
    margin-right: 0.48rem;
  }

  .btn-box a {
    color: #ffffff;
    padding: 0 5px 0 8px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    background: #ef8264;
    border-radius: 4px;
  }

  .btn-box a span {
    margin-right: 4px;
  }

  /* 关闭 */
  .close-icon {
    top: 0.12rem;
    right: 0.12rem;
    width: 20px;
    height: 20px;
  }

  .close-icon img {
    width: 100%;
    height: 100%;
  }
}
@media screen and (min-width: 1029px) {
  /* 内容box */
  .cart-content-box {
    width: 455px;
    min-height: 169px;
    background: #f0f9eb;
    border-radius: 10px;
    padding: 22px;
  }

  /* 提示 */
  .tip-box {
    font-size: 14px;
    font-weight: 500;
    color: #67c23a;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
  }

  .tip-box .icon-ok {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }

  .tip-box .icon-ok img {
    width: 100%;
    height: 100%;
  }

  /* 书or章节信息 */
  .cart-content-box .cont-box {
    display: flex;
  }

  /* 书的封面 */
  .cart-content-box .img-box {
    width: 64px;
    height: 88px;
  }

  .cart-content-box .img-box img {
    width: 100%;
    height: 100%;
  }

  /* title */
  .cart-content-box .goods-info {
    flex: 1;
    margin-left: 10px;
  }

  .cart-content-box .goods-info h3 {
    font-size: 16px;
    font-weight: 500;
    color: #3a3a3a;
    margin: 0 0 8px;
  }

  .cart-content-box .goods-info p {
    font-size: 14px;
    font-weight: 400;
    color: #929292;
    margin: 0;
  }

  /* 按钮 */
  .btn-box {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    font-size: 12px;
  }

  .btn-box .look-again-btn {
    cursor: pointer;
    width: 92px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    background: #ffeee9;
    border-radius: 4px;
    border: 1px solid #ef8264;
    color: #ef8264;
    margin-right: 48px;
  }

  .btn-box a {
    color: #ffffff;
    padding: 0 5px 0 8px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    background: #ef8264;
    border-radius: 4px;
  }

  .btn-box a span {
    margin-right: 4px;
  }

  /* 关闭 */
  .close-icon {
    top: 12px;
    right: 12px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .close-icon img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/addCartSuccess.vue